import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({
  title,
  description,
  keywords,
  image = 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=85,format=auto/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/webp-portservise-cover-2-85-11zon.webp',
  url,
  type = 'website',
  noindex = false,
  structuredData,
}) {
  const siteTitle = 'Pabst Teknik ApS | Portservice & Porte i Vejen og Syddanmark';
  const fullTitle = title ? `${title} | Pabst Teknik ApS` : siteTitle;
  const defaultDesc =
    'Pabst Teknik ApS – Din pålidelige partner inden for lovpligtigt portservice, eftersyn, reparation og montering af ledhejseporte, hurtigporte, gitterporte, fryseporte og Ajax alarmsystemer i hele Danmark.';
  const metaDescription = description || defaultDesc;
  const canonicalUrl = url ? `https://pabstteknik.dk${url}` : 'https://pabstteknik.dk';

  return (
    <Helmet>
      {/* Basic HTML Meta */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:site_name" content="Pabst Teknik ApS" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="da_DK" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data (JSON-LD) if provided */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
